/**
 * @fileoverview Servicio de gestión de carritos abandonados
 * Implementa arquitectura hexagonal con adaptadores para abstraer detalles de API
 * Incluye manejo defensivo, URLs absolutas, y registro de diagnóstico
 * @module cartService
 * @author Nubelytics Engineering
 */
import api from './apiClient';
import appConfig from '../infrastructure/config/AppConfig';

/**
 * Construye URL absoluta para endpoints de carritos utilizando la configuración centralizada
 * @param {string} endpoint - Endpoint relativo (ej: '/abandoned')
 * @returns {string} URL absoluta normalizada por entorno
 */
const getCartUrl = (endpoint) => {
  // Normalizar el endpoint (eliminar barra inicial si existe)
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  
  // Usar appConfig.getApiUrl que maneja correctamente la construcción de URLs
  // y evita duplicación de segmentos /api
  const resourcePath = `carts/${normalizedEndpoint}`; 
  const absoluteUrl = appConfig.getApiUrl(resourcePath);
  
  // Registrar para diagnóstico avanzado
  try {
    localStorage.setItem('nubelytics_carts_endpoint', endpoint);
    localStorage.setItem('nubelytics_carts_resource_path', resourcePath);
    localStorage.setItem('nubelytics_carts_absolute_url', absoluteUrl);
    console.debug('[cartService] URL construida:', absoluteUrl);
  } catch (e) {/* Error no crítico */}
  
  return absoluteUrl;
};

/**
 * Obtiene carritos abandonados con estrategia de resiliencia ante errores
 * @param {Object} params - Parámetros de consulta (rango de fechas, límites, etc.)
 * @returns {Promise<{data: Array}>} Carritos abandonados normalizados
 */
export const fetchAbandonedCarts = async (params) => {
  try {
    const response = await api.get('/carts/abandoned', { params });
    return response.data;
  } catch (error) {
    console.error('[cartService] Error fetching abandoned carts:', error);
    return { data: [], error: true };
  }
};
